import request from '@/utils/request';
import apiConstants from '@/utils/apiConstants';

const processIdParam = '{processId}';

/**
 * Reads the record of a background run.
 *
 * `current` is the one that matters for the screen being reopened: without it, the only way to know
 * about a run is to be the browser tab that started it, so a refresh loses the process and a second
 * person sees nothing at all.
 */
const backgroundProcessService = {
  getById(processId) {
    return request({
      url: apiConstants.END_POINTS.BILLING.BACKGROUND_PROCESS.replace(processIdParam, processId),
      method: 'get'
    });
  },
  getCurrent(processName) {
    return request({
      url: apiConstants.END_POINTS.BILLING.BACKGROUND_PROCESS_CURRENT,
      method: 'get',
      params: { name: processName }
    });
  },
  getItems(processId, status) {
    return request({
      url: apiConstants.END_POINTS.BILLING.BACKGROUND_PROCESS_ITEMS.replace(processIdParam, processId),
      method: 'get',
      params: status ? { status } : {}
    });
  },
  cancel(processId) {
    return request({
      url: apiConstants.END_POINTS.BILLING.BACKGROUND_PROCESS_CANCEL.replace(processIdParam, processId),
      method: 'post'
    });
  }
};

export default backgroundProcessService;
